export default __webpack_public_path__ + "static/media/bbb_logo_colour.2245a540.svg";